import { getCoverProcessingFeesSetting, hasProcessingFeeRate } from '@repo/lib';

// A manual payment option (invoice, cash) is not paid online, so there is no card fee to cover.
export function checkCanCoverProcessingFees({ page, paymentOption }) {
  const settings = getCoverProcessingFeesSetting(page);
  return (
    Boolean(settings?.enabled) && hasProcessingFeeRate(settings) && paymentOption?.type !== 'manual'
  );
}

// Until the customer clicks the box it follows the page's Preselect setting, so the editor
// preview moves with that setting.
export function getIsCoverProcessingFeeTicked({ page, form }) {
  return form?.coverProcessingFee ?? getCoverProcessingFeesSetting(page)?.preselected === true;
}

export default function checkIsCoverProcessingFeeSelected({ page, form, paymentOption }) {
  return (
    getIsCoverProcessingFeeTicked({ page, form }) &&
    checkCanCoverProcessingFees({ page, paymentOption })
  );
}
